import React, { useState, useEffect } from 'react'
import { Flex } from 'reflexbox/styled-components'

import useDebounce from 'hooks/debounce'

import { Input, InputLabel } from './styles'

const GoToPageInput = props => {
  const [value, setValue] = useState(props.value)
  const debouncedValue = useDebounce(value, 500)

  useEffect(() => {
    props.onChange(debouncedValue ? Number(debouncedValue) - 1 : 0)
  }, [debouncedValue])

  return (
    <Flex
      flexBasis='45%'
      minWidth='120px'
      flexGrow='1'
      alignItems={['center', 'center', 'flex-start']}
      flexDirection='column'
    >
      <Input {...props} type='number' min='1' onChange={e => setValue(e.target.value)} />

      <InputLabel>Ir para página:</InputLabel>
    </Flex>
  )
}

export default GoToPageInput
